import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent {

  @Input() titulo = 'Confirmar';
  @Input() mensaje = '';
  @Input() botonConfirmar = 'Aceptar';
  @Input() botonCancelar = 'Cancelar';
  @Input() botonSecundario = '';

  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onSecondary = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();

  confirmar(): void {
    this.onConfirm.emit();
  }

  cancelar(): void {
    this.onCancel.emit();
  }

  secundario(): void {
    this.onSecondary.emit();
  }

  cerrar(): void {
    this.onClose.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/confirm-modal/confirm-modal.component.ts